// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hmmPf","importantInfo":"styles_importantInfo__3JXWZ"};